import ReducerRegistry from '../base/redux/ReducerRegistry';
import * as CollabImageActionTypes from './actionTypes';
const initialState = {
    excalidrawApi: undefined,
    images: new Map(),
    isUploading: false
};
export const collabImagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case CollabImageActionTypes.JOIN_ROOM_SUCCESS: {
            const { payload } = action;
            const { images } = payload;
            const map = new Map(images.map(i => ([i.id, i])));
            return {
                ...state,
                images: map
            };
        }
        case CollabImageActionTypes.IMAGE_RECEIVED_DOWNLOAD_SUCCESS: {
            return recreateWithNewImage(state, action.payload.image);
        }
        case CollabImageActionTypes.LEFT_ROOM: {
            return {
                ...state,
                images: new Map()
            };
        }
        case CollabImageActionTypes.SHARE_IMAGE_UPLOAD_START: {
            return {
                ...state,
                isUploading: true
            };
        }
        case CollabImageActionTypes.SHARE_IMAGE_UPLOAD_SUCCESS: {
            return {
                ...recreateWithNewImage(state, action.payload.image),
                isUploading: false
            };
        }
        case CollabImageActionTypes.SHARE_IMAGE_UPLOAD_FAILURE: {
            return {
                ...state,
                isUploading: false
            };
        }
        case CollabImageActionTypes.SET_EXCALIDRAW_API: {
            return {
                ...state,
                excalidrawApi: action.payload.excalidrawApi
            };
        }
        case CollabImageActionTypes.REMOVE_IMAGE: {
            const { id } = action.payload;
            const newImages = new Map(state.images);
            newImages.delete(id);
            return {
                ...state,
                images: newImages
            };
        }
        default:
            return state;
    }
};
function recreateWithNewImage(state, image) {
    const { id } = image;
    const map = new Map(state.images);
    map.set(id, image);
    return { ...state, images: map };
}
ReducerRegistry.register('features/collab-images', collabImagesReducer);
